const TITLE_WEB = "microgravity"
const API_URL = "https://my.ugravity.net/api/"
const MAIN_API_URL = "https://www.p-tax.net/whale-api/"
const IMAGE_URL = "https://my.ugravity.net/images/"
const MODULE_ID = "16"
export { TITLE_WEB, API_URL, MAIN_API_URL, IMAGE_URL, MODULE_ID }
